module.exports = __webpack_public_path__ + "static/media/Customized Reports.c77ac6d7.svg";